import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { EUROPE } from 'enums/regions';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import get from 'lodash/get';
import { getNeedCaseFileDownloadInfo } from 'utils/projectFiles';
import { toast } from 'react-toastify';
import axios from 'axios';
import { DropzoneDialog } from 'material-ui-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { injectIntl } from 'react-intl';
import { useIntl } from 'react-intl';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;
const toastConfig = { autoClose: 3000 };

export const Project = ({ values, setFieldValue }) => {
  const needCaseRaw = get(values, 'data.needCase', false);
  const needCase = needCaseRaw === true;
  const needCaseFile = getNeedCaseFileDownloadInfo(values.data);
  const needCaseStudy = needCase ? 'SI' : 'NO';
  // const intl = useIntl();
  // Edition (upload) state - commented for view-only: only see file if exists
  // const [fileUploaded, setFileUploaded] = useState(Boolean(needCaseFile?.uuid));
  // const [fileName, setFileName] = useState('');
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [open, setOpen] = useState(false);

  const isEuropeCountry = EUROPE.includes(values.data.country);

  // Edition: sync file state - commented for view-only
  // useEffect(() => {
  //   setFileUploaded(Boolean(needCaseFile?.uuid));
  // }, [needCaseFile]);

  // TODO: issue dd5b5f54-99ee-4b5d-8965-7e22733c2d12, this can unified in a hook or utils function
  const handleDownloadFile = async () => {
    if (!needCaseFile?.uuid) {
      console.error('Need case file uuid is not available.');
      return;
    }

    try {
      const endUserFileUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        needCaseFile.uuid,
      )}`;
      const response = await axios.get(endUserFileUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });

      const fallbackName =
        needCaseFile.name ||
        (needCaseFile.key &&
          needCaseFile.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  // Edition (upload): subir archivo y guardar needCaseFileKey - commented for view-only
  // const handleSave = async (files) => {
  //   if (files.length > 0) {
  //     const file = files[0];
  //     const originalFileName = file.name;
  //     const newFileName = `end_user-${originalFileName}`;
  //     setFileName(originalFileName);
  //     const blob = new Blob([file], { type: file.type });
  //     const newFile = new File([blob], newFileName, { type: file.type });
  //     const data = new FormData();
  //     data.append('file', newFile);
  //     try {
  //       const url = `${API_URL}/bulk/upload`;
  //       const response = await axios.post(url, data, {
  //         headers: { Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}` },
  //       });
  //       if (response.status === 200) {
  //         if (typeof setFieldValue === 'function') setFieldValue('data.needCaseFileKey', response.data.key);
  //         setFileUploaded(true);
  //         setOpen(false);
  //         toast.success(<FormattedMessage id="El archivo se envió correctamente" />, toastConfig);
  //       } else throw new Error('Error en la respuesta del servidor');
  //     } catch (error) {
  //       console.error('Error al subir el archivo:', error);
  //       toast.error(<FormattedMessage id="Hubo un error al enviar el archivo" />, toastConfig);
  //     }
  //   }
  // };

  return (
    <>
      <div className="row">
        <div className="col-12 ViewOrEdit">
          <div>
            <strong>
              <FormattedMessage id="Nombre del proyecto:" />
            </strong>
            <span>{get(values, 'data.name', '-')}</span>
          </div>
          <div className="kt-space-20" />
          <div>
            <strong>
              <FormattedMessage id="Tipo de proyecto:" />
            </strong>
            <span>{get(values, 'data.type', '-')}</span>
          </div>
          <div className="kt-space-20" />
          <div>
            <strong>
              <FormattedMessage id="Principal necesidad:" />
            </strong>
            <span>{get(values, 'data.need', '-')}</span>
          </div>
          <div className="kt-space-20" />
          <div>
            <strong>
              <FormattedMessage id="Provincia:" />
            </strong>
            <span>{get(values, 'data.state', '-')}</span>
          </div>
          <div className="kt-space-20" />
          {isEuropeCountry && (
            <div>
              <strong>
                <FormattedMessage id="Case of Study:" />
              </strong>
              <span>
                {needCase ? (
                  <FormattedMessage id="SI" />
                ) : (
                  <FormattedMessage id="NO" />
                )}
              </span>
            </div>
          )}
          <div className="kt-space-20" />

          {/* View only: see file if exists (like dinoc viewProject). Edition (upload) commented below. */}
          {isEuropeCountry && needCase && (
            <div>
              {needCaseFile?.uuid ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GetAppIcon />}
                  onClick={handleDownloadFile}
                >
                  <FormattedMessage id="Descargar certificado end user" />
                </Button>
              ) : (
                <FormattedMessage id="No hay certificado end user" />
              )}
            </div>
          )}
          {/* Edition (upload): uncomment to allow upload + DropzoneDialog
          {isEuropeCountry && (
            <div>
              {!fileUploaded && needCaseStudy === 'SI' ? (<> <Button startIcon={<CloudUploadIcon />} ... /> <DropzoneDialog onSave={handleSave} ... /> </>) : fileUploaded && needCaseStudy === 'SI' ? (<Button startIcon={<GetAppIcon />} onClick={handleDownloadFile} ... />) : needCaseStudy === 'NO' ? <div></div> : null}
            </div>
          )}
          */}
          {/* <div>
          <strong>
            <FormattedMessage id="Ciudad:" />
          </strong>
          <span>{get(values, 'data.city', '-')}</span>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Project;
